module.exports = __webpack_public_path__ + "static/media/filter.e25354ba.svg";